import PropTypes from 'prop-types';
import React from 'react';
import { List as IList } from 'immutable';
import Icon from 'flow/components/ui-components/Icon';
import Checkbox from 'flow/components/ui-components/Checkbox';

import {
    SortableContainer,
    SortableElement,
    SortableHandle,
} from 'react-sortable-hoc';

const DragHandle = SortableHandle(() => <Icon iconKey="dragHandle" />);

class CheckboxListDraggable extends React.PureComponent {
    static propTypes = {
        items: PropTypes.instanceOf(IList).isRequired,
        onItemsUpdate: PropTypes.func.isRequired,
        maxSelectionAmount: PropTypes.number,
    };

    constructor(props) {
        super(props);

        this.state = {
            itemsAllSorted: props.items,
        };
    }

    renderCheckboxListItem = (item, DragHandle, disabled) => {
        return (
            <li
                key={item.get('key')}
                className="relative z-30 list-none rounded-sm p-1 hover:bg-gray-100"
            >
                <div className="flex w-full items-center justify-between">
                    <div className="flex items-center">
                        <Checkbox
                            label={item.get('value')}
                            key={item.get('key')}
                            checked={!!item.get('selected')}
                            disabled={disabled}
                            onChange={(event, value) =>
                                this.onCheckboxChange(
                                    event,
                                    value,
                                    item.get('key'),
                                )
                            }
                        />
                    </div>
                    <div className="cursor-move rounded-sm p-1 hover:bg-gray-200">
                        <DragHandle className="rounded-sm text-gray-600" />
                    </div>
                </div>
            </li>
        );
    };

    onCheckboxChange = (_event, value, key) => {
        const { onItemsUpdate } = this.props;
        const { itemsAllSorted } = this.state;

        const index = itemsAllSorted.findIndex(
            (item) => item.get('key') === key,
        );
        const item = itemsAllSorted.get(index).set('selected', value);
        const itemsUpdated = itemsAllSorted.set(index, item);

        this.setState({ itemsAllSorted: itemsUpdated });
        onItemsUpdate(itemsUpdated);
    };

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { onItemsUpdate } = this.props;
        const { itemsAllSorted } = this.state;

        const itemToMove = itemsAllSorted.get(oldIndex);
        const listNew = itemsAllSorted
            .delete(oldIndex)
            .insert(newIndex, itemToMove);

        this.setState({ itemsAllSorted: listNew });
        onItemsUpdate(listNew);
    };

    render() {
        const { maxSelectionAmount } = this.props;
        const { itemsAllSorted } = this.state;

        const itemsSelected = itemsAllSorted.filter((item) =>
            item.get('selected'),
        );
        const maximumItemsSelected =
            itemsSelected &&
            maxSelectionAmount &&
            itemsSelected.size >= maxSelectionAmount;

        const SortableItem = SortableElement(({ value }) => {
            const disabled =
                (maximumItemsSelected && !value.get('selected')) ||
                value.get('disabled');
            return this.renderCheckboxListItem(value, DragHandle, disabled);
        });

        const SortableList = SortableContainer(({ items }) => {
            return (
                <ul>
                    {items.map((value, index) => (
                        <SortableItem
                            key={`item-${index}`}
                            index={index}
                            value={value}
                        />
                    ))}
                </ul>
            );
        });

        return (
            <SortableList
                items={itemsAllSorted}
                onSortEnd={this.onSortEnd}
                useDragHandle={true}
            />
        );
    }
}

export default CheckboxListDraggable;
